<div edsFlexbox flexDirection="column">
  <div edsFlexbox flexDirection="row" justifyContent="space-between">
    <div>
      <span class="small">{{
        "products.gross-expense-ratio" | translate
      }}</span>
    </div>
    <div>
      {{ charges?.expenseRatioGross ? charges.expenseRatioGross : "—" }}
    </div>
  </div>
  <div edsFlexbox flexDirection="row" justifyContent="space-between">
    <div>
      <span class="small">
        {{ "products.net-expense-ratio" | translate }}
      </span>
      <eds-icon
        class="print-hidden"
        *ngIf="tooltipContent"
        type="info"
        size="small"
        edsTooltip
        [analyticsName]="'products.net-expense-ratio' | translate"
        tooltipType="medium"
        [tooltipContent]="tooltipContent"
        [tooltipPositionDefault]="showTooltipAtTop ? 'top' : 'bottom'"
        tooltipBehavior="fixed"
      ></eds-icon>
    </div>
    <div>
      {{ charges?.expenseRatioNet ? charges.expenseRatioNet : "—" }}
    </div>
  </div>
</div>
